export default {
	paths: {
		main: 'src/main.ssr', // Without file extension
	},
	plugins: ['../../uvue-plugins/vuex.js', '../../uvue-plugins/apollo.js'],
};
